/* eslint-disable linebreak-style */
/* eslint-disable comma-dangle */
import PropTypes from 'prop-types';
import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Navigate, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import Wallet from '../components/Wallet/Wallet';
import SendVerificationEmail from '../components/SendVerificationEmail/SendVerificationEmail';
import './UserPage.css';

// import { WalletKitProvider } from '@mysten/wallet-kit';

function TalofaNavbar() {
  const navigate = useNavigate();
  function logOut() {
    window.sessionStorage.clear();
    navigate('/');
  }
  return (
    <div className="navbar">
      <Navbar collapseOnSelect bg="dark" expand="lg" variant="dark">
        <Navbar.Brand href="#home">
          <Nav.Link href="/">
            <picture>
              {/* <source srcSet="./logoTransparent.jpeg" type="image/webp" />
              <source srcSet="./logoTransparent.jpeg" type="image/jpeg" /> */}
              <img className="talofa_logo" src="./logoTransparent.png" alt=""/>
            </picture>
          </Nav.Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto" />
          <Nav>
            <Nav.Link target="_blank" href="https://www.talofagames.com/faq">FAQ</Nav.Link>
            <Nav.Link onClick={() => { logOut(); }} href="#">Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

function UserPage(props) {
  const {
    userData,
    playerVerified,
    setPlayerVerified
  } = props;

  const navigate = useNavigate();

  if (!window.sessionStorage.getItem('entity_token')) {
    navigate('/');
    return (
      <Navigate replace to="/" />
    );
  }

  let username = window.sessionStorage.getItem('username');
  if (username === 'undefined') {
    username = '';
  }

  return (
    <>
      <TalofaNavbar />
      <div className="title-header user-page-header">

        <div className="welcome-message">
          <img className="badge" src="badge.png" alt="" />

          <p className="header">
            Welcome Back
            {' '}
            {username ?? ''}
          </p>
        </div>
      </div>
      { !playerVerified && (<SendVerificationEmail setPlayerVerified={setPlayerVerified} />) }
      { playerVerified && (<Wallet userData={userData} />) }
      <Footer />
    </>
  );
}

UserPage.propTypes = {
  userData: PropTypes.bool.isRequired,
  playerVerified: PropTypes.bool.isRequired,
  setPlayerVerified: PropTypes.func.isRequired
};

export default UserPage;
